import { CSSObject } from '@mui/material/styles';
import { Drawer } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { SIDEBAR_COLORS } from '@/common/presentation/constants/colors';

const drawerWidth = 260;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  backgroundColor: SIDEBAR_COLORS.BACKGROUND,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),
  overflowX: 'hidden'
});

const closedMixin = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '5rem',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),
  overflowX: 'hidden',
  backgroundColor: SIDEBAR_COLORS.BACKGROUND,
  width: `calc(${theme.spacing(10)} + 1px)`
});
const StyledDrawer = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  padding: '0 1rem',
  backgroundColor: theme.palette.background.paper,
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.background.paper,
    zIndex: 1099,
    color: 'text.primary',
    borderRight: 'none'
  },

  boxSizing: 'border-box',
  variants: [
    {
      props: ({ open }) => open,
      style: {
        ...openedMixin(theme),
        '& .MuiDrawer-paper': openedMixin(theme)
      }
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        '& .MuiDrawer-paper': closedMixin(theme)
      }
    }
  ]
}));

export default StyledDrawer;
